import ListIcon from '@material-ui/icons/ListTwoTone';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useUrlToTitleElements } from '../../../api/products/catalogue';
import AppBreadcrumbs, { AppBreadcrumbsProps } from '../../../components/AppBreadcrumbs';
import StyledBreadcrumb from '../../../components/StyledBreadcrumb';
import { localeState } from '../../../api/appState';

export type CataloguePageListBreadcrumbsProps = AppBreadcrumbsProps;

const CataloguePageListBreadcrumbs = React.forwardRef<HTMLDivElement, CataloguePageListBreadcrumbsProps>(
  (props, ref) => (
    <React.Suspense fallback={<Skeleton variant='rect' width={'100%'} />}>
      <CataloguePageListBreadcrumbsInner ref={ref} {...props} />
    </React.Suspense>
  ),
);

CataloguePageListBreadcrumbs.displayName = 'CataloguePageListBreadcrumbs';

export default CataloguePageListBreadcrumbs;

const CataloguePageListBreadcrumbsInner = React.forwardRef(() => {
  const match = useRouteMatch();
  const titleElements = useUrlToTitleElements(match.url);
  const locale = useRecoilValue(localeState);

  return (
    <AppBreadcrumbs disableHome>
      {titleElements.map((item) => (
        <StyledBreadcrumb
          key={item.code}
          to={`/${locale}${item.code}`}
          label={item.label}
          icon={item.code === '/catalogue' ? <ListIcon fontSize='small' /> : undefined}
        />
      ))}
    </AppBreadcrumbs>
  );
});

CataloguePageListBreadcrumbsInner.displayName = 'CataloguePageListBreadcrumbsInner';
